import FieldTitle, { FieldTitleProps } from './field-title';

export type { FieldTitleProps };
export default FieldTitle;
